import { useLayoutEffect, useState } from 'react';

/**
 * 문단 로드 후 컬럼 높이 측정 → totalPages 계산 (snap 영역용)
 */
export const useColumnSnapPages = (
  contentRef: React.RefObject<HTMLDivElement>,
  paragraphs: unknown[]
): number => {
  const [totalPages, setTotalPages] = useState(0);

  useLayoutEffect(() => {
    const el = contentRef.current;
    if (!el || paragraphs.length === 0) return;

    const measure = () => {
      el.style.columnWidth = 'auto';
      el.style.height = 'auto';
      el.style.width = '100vw';

      const totalContentHeight = el.scrollHeight;
      const pageHeight = el.parentElement?.clientHeight || window.innerHeight;

      const safePages = Math.ceil(totalContentHeight / pageHeight);
      setTotalPages(safePages > 0 ? safePages : 1);

      el.style.columnWidth = '100vw';
      el.style.height = '100%';
      el.style.width = `${safePages * 100}vw`;
    };

    const frameId = requestAnimationFrame(measure);

    return () => cancelAnimationFrame(frameId);
  }, [contentRef, paragraphs]);

  return totalPages;
}
